import PropertyProcurementImage from "../../assets/GLNavigationIcon/PropertyProcurement.svg";
import GEOImage from "../../assets/GLNavigationIcon/GEO Go.svg";
import GLImage from "../../assets/GLNavigationIcon/GLFunnelCRM.svg";
import HRImage from "../../assets/GLNavigationIcon/HR.svg";
import TaskImage from "../../assets/GLNavigationIcon/Task Manager.svg";
import AccountImage from "../../assets/GLNavigationIcon/Accounts Pro.svg";
import MorningImage from "../../assets/GLNavigationIcon/MorningImage.jpg";
import AfternoonImage from "../../assets/GLNavigationIcon/AfternoonImage.jpg"
import EveningImage from "../../assets/GLNavigationIcon/EveningImage.jpg"

import ManualIcon from "../../assets/PropertyProcurementAssets/PropertyAddImages/manualIcon.svg";
import AutoIcon from "../../assets/PropertyProcurementAssets/PropertyAddImages/autoIcon.svg"


import ScanGIF from "../../assets/PropertyProcurementAssets/LoadingGIF/scan.gif";



const Images = {
  PropertyProcurementImage,
  GEOImage,
  GLImage,
  HRImage,
  TaskImage,
  AccountImage,
  MorningImage,
  AfternoonImage,
  EveningImage,

  ManualIcon,
  AutoIcon,


  ScanGIF

};

export default Images;
